export enum AiGenerationMode {
  Manual = 'MANUAL',
  AiAssisted = 'AI_ASSISTED',
  Guided = 'GUIDED'
}
